import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Tab } from "@heroui/react";
import { useTranslation } from "react-i18next";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useUserProfile from "../../hooks/useUserProfile";
import EmailContentAdvanced from "./EmailContentAdvanced";
import UserActionsFeed from "./UserActionsFeed.jsx";
import PaginationComponent from "./PaginationComponent";
import BasicExampleWithImage from "./Shapes.tsx";
import DebugPanel from "./DebugPanel.tsx";

export default function Errororder() {
  const { t } = useTranslation();
  const params = useParams();
  const axiosPrivate = useAxiosPrivate();
  const { isAdminVistaflow } = useUserProfile();
  const [dataForm, setDataForm] = useState();

  // Get order ID
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getOrder = async () => {
      try {
        const response = await axiosPrivate.get(`/orders/${params.orderId}`, {
          signal: controller.signal,
        });
        if (isMounted) {
          setDataForm(response.data);
        }
      } catch (err) {
        console.log("Catch error axios : " + JSON.stringify(err, null, 2));
      }
    };

    getOrder();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [axiosPrivate, params.orderId]);

  const classNames = React.useMemo(
    () => ({
      tabList: "gap-6 w-full relative rounded-none p-0 border-b border-divider",
      cursor: "w-full bg-vistagreen",
      tab: "max-w-fit px-0 h-12 border-vistagreen",
      tabContent: "group-data-[selected=true]:text-vistagreen",
      panel: ["w-full bg-white rounded-lg"],
      base: ["pt-6 "],
    }),
    [],
  );

  const [page, setPage] = React.useState(1);
  const pages = dataForm?.process?.email?.images?.length;
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <div className="flex">
        <div className="w-6/12 mr-8 p-3 bg-white rounded-lg">
          <PaginationComponent
            page={page}
            pages={pages}
            onPageChange={handlePageChange}
          />

          <BasicExampleWithImage
            orderImage={dataForm?.process?.email.images[page - 1]}
            urlPdf={dataForm?.process?.email?.input_presigned}
            orderId={params.orderId}
          />
        </div>

        <div className="w-6/12">
          <div className="flex w-full flex-col">
            <Tabs
              aria-label={t("options")}
              variant="underlined"
              classNames={classNames}
            >
              <Tab key="mail" title={t("original_mail")}>
                <div className="p-5 text-sm">
                  {dataForm?.process ? (
                    <EmailContentAdvanced orderId={dataForm?.process?.jobID} />
                  ) : (
                    <p>{t("no_content")}</p>
                  )}
                </div>
              </Tab>
              <Tab key="logs" title={t("action_history")}>
                <UserActionsFeed dataForm={dataForm} />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
      {isAdminVistaflow && <DebugPanel orderId={params.orderId} dataForm={dataForm} />}
    </>
  );
}